// src/Atoms/AtomButtonSimple/AtomButtonSimple.js
// Atom : Bouton réutilisable avec styles Bootstrap.

import React from 'react';
import PropTypes from 'prop-types';

const AtomButtonSimple = ({ onClick, disabled, children, className  }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={` ${className}`}
    >
      {children}
    </button>
  );
};


AtomButtonSimple.propTypes = {
  onClick: PropTypes.func.isRequired, // onClick est obligatoire et doit être une fonction.
  disabled: PropTypes.bool,          // disabled est optionnel et doit être un booléen.
  children: PropTypes.node,          // children est optionnel et doit être un noeud React.
  className: PropTypes.string,       // className est optionnel et doit être une chaîne.
};

AtomButtonSimple.defaultProps = {
  disabled: false,                   // Par défaut, disabled est false.
  className: '',                     // Par défaut, className est une chaîne vide.
};


export default AtomButtonSimple;
